import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/api/client';
import { API_HOME_TASKS } from '@/api/endpoints';
import { HOME_TASK_QUERY_KEY } from '@/api/queryKeys';
import type { HomeTaskDetailsResponse } from '@/types/diary';
import { unwrapAxiosResponse } from '@/utils/axios';

export const useHomeTask = (homeTaskId: number) =>
  useQuery({
    queryKey: [...HOME_TASK_QUERY_KEY, homeTaskId],
    queryFn: () =>
      apiClient
        .get<HomeTaskDetailsResponse>(`${API_HOME_TASKS}/${homeTaskId}`)
        .then(unwrapAxiosResponse),
  });
